export const getCollection = ({ teacher }) => teacher.assessment.collection;

export const getGradeId = ({ teacher }) => teacher.spreadsheet.selectedGrade.id;
